import type {Caption} from '@remotion/captions';
import {zColor} from '@remotion/zod-types';
import {z} from 'zod';

export const audioStorySchema = z.object({
	title: z.string(),
	subtitle: z.string(),
	episode: z.string(),
	accentColor: zColor(),
	audioFile: z.string(),
	captionsFile: z.string(),
});

export type AudioStoryProps = z.infer<typeof audioStorySchema> & {
	readonly captions: Caption[] | null;
};
